import { apiRequest } from './client'

export type BodyType = 'json' | 'text' | 'xml' | 'binary_base64'

export interface MockResponse {
  id: string
  project_id: string
  name: string | null
  status: number
  headers: Record<string, string>
  body: string | null
  body_type: BodyType
  delay_ms: number
  created_at: string
  updated_at: string
}

export interface CreateResponseInput {
  name?: string
  status: number
  headers?: Record<string, string>
  body?: string
  body_type: BodyType
  delay_ms?: number
}

export function getResponse(id: string): Promise<MockResponse> {
  return apiRequest<MockResponse>(`/api/responses/${id}`)
}

export function createResponse(projectId: string, input: CreateResponseInput): Promise<MockResponse> {
  return apiRequest<MockResponse>(`/api/projects/${projectId}/responses`, {
    method: 'POST',
    body: input,
  })
}
